import React from "react";

const SITE = "https://flexlines.store";
const DEFAULT_IMAGE = `${SITE}/og-default.png`;

/**
 * SEO head tags for public pages. Uses React 19 native document metadata —
 * <title>, <meta>, and <link> rendered here are hoisted to <head> automatically.
 * Use only on indexable/public routes (Landing, Poster, legal pages).
 */
export function Seo({ title, description, path = "/", image = DEFAULT_IMAGE, noindex = false }) {
    const url = `${SITE}${path}`;
    return (
        <>
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />
            {noindex && <meta name="robots" content="noindex,nofollow" />}
            {/* Open Graph */}
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Flex Line" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
        </>
    );
}

export default Seo;
